;(function () {
	'use strict';

	if (!customElements.get('testimonials-component')) {
		class TestimonialsComponent extends HTMLElement {
			constructor() {
				super();
				this.track        = null;
				this.slides       = [];
				this.pagination   = null;
				this.currentIndex = 0;
				this.perView      = 1;
				this.spaceBetween = 15;
			}

			connectedCallback() {
				this.track      = this.querySelector('.ab-test-track');
				this.slides     = Array.from(this.querySelectorAll('.ab-test-slide'));
				this.pagination = this.querySelector('.ab-test-pagination');

				if (!this.track || this.slides.length === 0) return;

				this._buildPagination();
				this.init();
				window.addEventListener('resize', () => this.init());
				this.track.addEventListener('scroll', () => this._onScroll(), { passive: true });
			}
		}

		TestimonialsComponent.prototype._getConfig = function () {
			const w = window.innerWidth;
			const perViewDesktop = parseFloat(this.dataset.slidesPerView) || 3;

			if (w >= 1200) {
				return { perView: perViewDesktop, spaceBetween: 70 };
			} else if (w >= 750) {
				return { perView: 1.5, spaceBetween: 30 };
			} else {
				return { perView: 1, spaceBetween: 15 };
			}
		};

		TestimonialsComponent.prototype.init = function () {
			const { perView, spaceBetween } = this._getConfig();
			this.perView      = perView;
			this.spaceBetween = spaceBetween;

			const containerWidth = this.track.clientWidth;
			const slideWidth     = (containerWidth - spaceBetween * (perView - 1)) / perView;

			this.slides.forEach((slide, i) => {
				slide.style.width       = slideWidth + 'px';
				slide.style.marginRight = i < this.slides.length - 1 ? spaceBetween + 'px' : '0';
			});

			// Side padding so the first and last slide can be scrolled to center
			const sidePadding = (containerWidth - slideWidth) / 2;
			this.track.style.paddingLeft  = sidePadding + 'px';
			this.track.style.paddingRight = sidePadding + 'px';

			// Restore position after resize without animation
			const current = this.slides[this.currentIndex];
			if (current) {
				current.scrollIntoView({ behavior: 'instant', inline: 'center', block: 'nearest' });
			}
		};

		TestimonialsComponent.prototype._buildPagination = function () {
			if (!this.pagination) return;
			this.pagination.innerHTML = '';
			this.slides.forEach((_, i) => {
				const dot = document.createElement('button');
				dot.className = 'ab-test-dot' + (i === 0 ? ' active' : '');
				dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
				dot.addEventListener('click', () => {
					this.currentIndex = i;
					this.slides[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
					this._updateDots();
				});
				this.pagination.appendChild(dot);
			});
		};

		TestimonialsComponent.prototype._onScroll = function () {
			const containerCenter = this.track.scrollLeft + this.track.clientWidth / 2;
			let closest = 0;
			let minDiff = Infinity;

			this.slides.forEach((slide, i) => {
				const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
				const diff = Math.abs(slideCenter - containerCenter);
				if (diff < minDiff) { minDiff = diff; closest = i; }
			});

			if (closest !== this.currentIndex) {
				this.currentIndex = closest;
				this._updateDots();
			}
		};

		TestimonialsComponent.prototype._updateDots = function () {
			if (!this.pagination) return;
			this.pagination.querySelectorAll('.ab-test-dot').forEach((dot, i) => {
				dot.classList.toggle('active', i === this.currentIndex);
			});
		};

		customElements.define('testimonials-component', TestimonialsComponent);
	}
})();
